// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0e48ab36]:root{--q-color-primary:#4f75ff;--q-color-secondary:#20e4ff;--q-color-accent:#de06e2;--q-color-positive:#03b469;--q-color-negative:#d92057;--q-color-info:#ffe600;--q-color-warning:#ff9b04;--q-color-dark:#161820}.project-details[data-v-0e48ab36]{border-bottom:1px solid #000;padding:16px 16px;background:#fff}.project-row[data-v-0e48ab36]{background:grey;color:#fff;padding:6px 16px}", ""]);
// Exports
module.exports = exports;
